var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/index.ts
import { overrideEnvConfigQueryParamName as overrideEnvConfigQueryParamName2 } from "@getvim-communication/management";

// src/vim-communication.ts
import sysend from "sysend";
import { v4 as uuid } from "uuid";
import {
  getProxiesByEnv,
  overrideEnvConfigQueryParamName,
  vimCommunicationModuleName
} from "@getvim-communication/management";
import { logger } from "@getvim/vim-connect-logger";
var VimCommunicationEvents = /* @__PURE__ */ ((VimCommunicationEvents2) => {
  VimCommunicationEvents2["SubAppIsReady"] = "SubAppIsReady";
  VimCommunicationEvents2["WidgetIsReady"] = "VimCommunicationWidgetIsReady";
  VimCommunicationEvents2["WidgetIsReadyResolved"] = "VimCommunicationWidgetIsReadyResolved";
  VimCommunicationEvents2["GetProductConfig"] = "GetProductConfig";
  VimCommunicationEvents2["GetAccessToken"] = "GetAccessToken";
  return VimCommunicationEvents2;
})(VimCommunicationEvents || {});
var vimCommunicationEvents = Object.values(VimCommunicationEvents);
var SYNC_EVENT_TIMEOUT = 2e4;
var eventMessageStyle = ["background: #ffb347; color: black;", ""];
var senderIdMessageStyle = ["background: #966fd6; color: black;", ""];
var isProduction = true;
var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var VimCommunication = class {
  constructor({
    moduleId,
    tabId,
    moduleNames,
    options: { overrideWidgetsConfig, verboseMode = isProduction } = {}
  }) {
    this.verboseMode = false;
    this.resolveCommunicationPromise = () => {
    };
    this.eventCallbacks = /* @__PURE__ */ new Map();
    this.eventsMapQueue = /* @__PURE__ */ new Map();
    this.handleEvent = async (message) => {
      const { event, senderId, tabId, isSync } = message;
      if (tabId !== this.tabId) {
        return;
      }
      const shouldLog = this.verboseMode || !this.isVimCommunicationEvent(event);
      const callbacks = this.eventCallbacks.get(event) || [];
      callbacks.forEach((callback) => {
        shouldLog && this.logger.debug(
          `\u{1F389} ${isSync ? "\u{1F4AB} Sync " : ""}Event %c[${event}]%c received from %c[${senderId}]%c:`,
          { message, data: message == null ? void 0 : message.data },
          { messageStyle: [...eventMessageStyle, ...senderIdMessageStyle] }
        );
        callback(message);
      });
      if (callbacks.length === 0) {
        this.logger.debug("Listener was not initialized yet for this event, queueing the message", {
          message
        });
        this.eventsMapQueue.set(event, message);
      }
    };
    this.moduleId = moduleId;
    this.logger = logger.scope(this.moduleId, {
      moduleName: vimCommunicationModuleName,
      moduleAndScopeSameColor: true
    });
    this.tabId = tabId;
    this.moduleNames = moduleNames;
    this.verboseMode = verboseMode;
    this.overrideWidgetsConfig = overrideWidgetsConfig || this.getOverrideConfigFromUrl();
    this.isCommunicationReadyPromise = new Promise((resolve) => {
      this.resolveCommunicationPromise = resolve;
    });
    this.initProxies();
    sysend.off(this.moduleId);
    sysend.on(this.moduleId, this.handleEvent);
  }
  listenToEvent(event, callback) {
    this.verboseMode && this.logger.debug(
      `\u{1F442} Listening to event %c[${event}]%c in %c[${this.moduleId}]%c`,
      void 0,
      { messageStyle: [...eventMessageStyle, ...senderIdMessageStyle] }
    );
    this.addEventCallback(event, callback);
    return () => {
      this.removeEventCallback(event, callback);
      this.verboseMode && this.logger.debug(
        `\u{1F6AB} Unregistering event %c[${event}]%c in %c[${this.moduleId}]%c`,
        void 0,
        { messageStyle: [...eventMessageStyle, ...senderIdMessageStyle] }
      );
    };
  }
  listenToSyncEvent(event, callback) {
    const syncCallback = async (incomingMessage) => {
      const { senderId, messageId } = incomingMessage;
      let response;
      try {
        response = await callback(incomingMessage);
      } catch (error) {
        response = { error };
      }
      const message = this.generateMessage(event, response, { isSync: true, messageId });
      sysend.broadcast(senderId, message);
    };
    return this.listenToEvent(event, syncCallback);
  }
  async sendEvent(widgetId, event, data = {}) {
    await this.isCommunicationReadyPromise;
    const message = this.generateMessage(event, data);
    sysend.broadcast(widgetId, message);
    const shouldLog = this.verboseMode || !this.isVimCommunicationEvent(event);
    shouldLog && this.logger.debug(
      `\u{1F680} Event %c[${event}]%c sent to %c[${widgetId}]%c`,
      {
        message,
        data: message == null ? void 0 : message.data
      },
      { messageStyle: [...eventMessageStyle, ...senderIdMessageStyle] }
    );
  }
  async sendSyncEvent(widgetId, event, data = {}) {
    await this.isCommunicationReadyPromise;
    let resolve;
    let reject;
    const promise = new Promise((promiseResolve, promiseReject) => {
      resolve = promiseResolve;
      reject = promiseReject;
    });
    const message = this.generateMessage(event, data, { isSync: true });
    const timeout = setTimeout(() => {
      reject("Sync event timeout! event took too long to respond.");
      removeListener();
    }, SYNC_EVENT_TIMEOUT);
    const removeListener = this.listenToEvent(event, (incomingMessage) => {
      if ((incomingMessage == null ? void 0 : incomingMessage.messageId) !== message.messageId) {
        return;
      }
      clearTimeout(timeout);
      removeListener();
      const result = incomingMessage == null ? void 0 : incomingMessage.data;
      if (result == null ? void 0 : result.error) {
        reject(result.error);
      } else {
        resolve(result);
      }
    });
    sysend.broadcast(widgetId, message);
    const shouldLog = this.verboseMode || !this.isVimCommunicationEvent(event);
    shouldLog && this.logger.debug(
      `\u{1F680} \u{1F4AB} Sync Event %c[${event}]%c sent to %c[${widgetId}]%c:`,
      {
        message,
        data: message == null ? void 0 : message.data
      },
      { messageStyle: [...eventMessageStyle, ...senderIdMessageStyle] }
    );
    return await promise;
  }
  generateMessage(event, data, { isSync = false, messageId } = {}) {
    return {
      isSync,
      messageId: messageId != null ? messageId : uuid(),
      senderId: this.moduleId,
      tabId: this.tabId,
      event,
      data
    };
  }
  async addEventCallback(event, callback) {
    const callbacks = this.eventCallbacks.get(event) || [];
    callbacks.push(callback);
    this.eventCallbacks.set(event, callbacks);
    const queuedMessage = this.eventsMapQueue.get(event);
    if (queuedMessage) {
      this.logger.debug("Triggering callback with queued message", { queuedMessage });
      callbacks.forEach((cb) => cb(queuedMessage));
      this.eventsMapQueue.delete(event);
    }
  }
  removeEventCallback(event, callback) {
    const callbacks = this.eventCallbacks.get(event) || [];
    const index = callbacks.indexOf(callback);
    if (index > -1) {
      callbacks.splice(index, 1);
    }
    this.eventCallbacks.set(event, callbacks);
  }
  async initProxies() {
    if (this.overrideWidgetsConfig) {
      this.verboseMode && this.logger.debug(`\u{1F608} Overriding widgets env`, this.overrideWidgetsConfig);
    }
    const proxies = await getProxiesByEnv({
      moduleNames: this.moduleNames,
      overrideWidgetsConfig: this.overrideWidgetsConfig,
      logger: this.logger
    });
    if (this.verboseMode) {
      this.logger.debug("Initializing proxies", { proxies });
    }
    this.injectProxies(proxies);
  }
  getOverrideConfigFromUrl() {
    try {
      const overrideEnvConfig = new URL(window.location.href).searchParams.get(
        overrideEnvConfigQueryParamName
      );
      if (overrideEnvConfig) {
        const config = base64regex.test(overrideEnvConfig) ? window.atob(overrideEnvConfig) : overrideEnvConfig;
        return JSON.parse(config);
      }
    } catch (error) {
      this.verboseMode && this.logger.debug(`Failed to get override config from url`, error);
      return;
    }
    return void 0;
  }
  injectProxies(proxies) {
    proxies.forEach((proxyUrl) => {
      if (document.querySelectorAll(`iframe[src='${proxyUrl}']`).length === 0) {
        sysend.proxy(proxyUrl);
      }
    });
    setTimeout(() => {
      this.verboseMode && this.logger.debug(`\u2705 Injected all proxies!`);
      this.resolveCommunicationPromise();
      this.onCommunicationReady();
    }, 1e3);
  }
  isVimCommunicationEvent(event) {
    return vimCommunicationEvents.includes(event);
  }
};

// src/runtime-vim-communication.ts
import { ModuleNames as ModuleNames2 } from "@getvim-communication/management";
var vimCommunicationModules = Object.values(ModuleNames2);
var RuntimeVimCommunication = class extends VimCommunication {
  constructor(_a) {
    var _b = _a, {
      onWidgetReady,
      getProductConfig,
      getAccessToken
    } = _b, superProps = __objRest(_b, [
      "onWidgetReady",
      "getProductConfig",
      "getAccessToken"
    ]);
    super(__spreadValues({ moduleId: ModuleNames2.Runtime, moduleNames: vimCommunicationModules }, superProps));
    this.onWidgetReady = onWidgetReady;
    this.getProductConfig = getProductConfig;
    this.getAccessToken = getAccessToken;
  }
  onCommunicationReady() {
    this.logger.info(`\u2705 Module is ready!`, this);
    this.listenToEvent("VimCommunicationWidgetIsReady" /* WidgetIsReady */, ({ senderId }) => {
      this.sendEvent(senderId, "VimCommunicationWidgetIsReadyResolved" /* WidgetIsReadyResolved */);
      this.onWidgetReady(senderId);
    });
    this.listenToSyncEvent("GetProductConfig" /* GetProductConfig */, async ({ data }) => {
      const applicationName = data == null ? void 0 : data.applicationName;
      return await this.getProductConfig(applicationName);
    });
    this.listenToSyncEvent("GetAccessToken" /* GetAccessToken */, this.getAccessToken);
  }
};

// src/widget-vim-communication.ts
import { ModuleNames as ModuleNames3 } from "@getvim-communication/management";
var WIDGET_IS_READY_RETRY_TIMEOUT = 1e3;
var WIDGET_IS_READY_TIMEOUT = 15e3;
var WidgetVimCommunication = class extends VimCommunication {
  constructor(_a) {
    var _b = _a, { moduleNames } = _b, superProps = __objRest(_b, ["moduleNames"]);
    const widgetModules = [.../* @__PURE__ */ new Set([...moduleNames || [], ModuleNames3.Runtime])];
    super(__spreadProps(__spreadValues({}, superProps), { moduleNames: widgetModules }));
    this.isReadyPromiseResolve = () => {
    };
    this.isReadyPromise = new Promise((resolve) => {
      this.isReadyPromiseResolve = resolve;
    });
  }
  onCommunicationReady() {
    this.logger.info(`\u2705 Module is ready!`, this);
    let isReady = false;
    const retryTimeout = setTimeout(() => {
      isReady = true;
      removeListener();
      if (this.tabId !== "0") {
        this.logger.error(`\u{1F480} Widget failed to contact Runtime! Timeout reached.`, this);
      } else {
        this.logger.warning(
          `\u{1F480} Widget failed to contact Runtime! Timeout reached. [unsupported by current MSI version?]`,
          this
        );
      }
    }, WIDGET_IS_READY_TIMEOUT);
    const removeListener = this.listenToEvent("VimCommunicationWidgetIsReadyResolved" /* WidgetIsReadyResolved */, () => {
      isReady = true;
      clearTimeout(retryTimeout);
      removeListener();
      this.logger.info(`\u2705 Widget is ready!`, this);
      this.isReadyPromiseResolve();
    });
    const handleWidgetIsReady = () => {
      if (isReady) {
        return;
      }
      this.sendEvent(ModuleNames3.Runtime, "VimCommunicationWidgetIsReady" /* WidgetIsReady */);
      setTimeout(handleWidgetIsReady, WIDGET_IS_READY_RETRY_TIMEOUT);
    };
    handleWidgetIsReady();
  }
  async getProductConfig(applicationName) {
    await this.isReadyPromise;
    return await this.sendSyncEvent(ModuleNames3.Runtime, "GetProductConfig" /* GetProductConfig */, {
      applicationName
    });
  }
  async getAccessToken() {
    await this.isReadyPromise;
    return await this.sendSyncEvent(ModuleNames3.Runtime, "GetAccessToken" /* GetAccessToken */);
  }
};

// src/sub-application-vim-communication.ts
import { CommonConnector } from "@getvim/extension-connector";
var VimConnectSubApp = class {
  constructor(vimCommunication, widgetConfig) {
    this.vimCommunication = vimCommunication;
    this.widgetConfig = widgetConfig;
  }
  async injectWidget() {
    const promise = new Promise(async (resolve, reject) => {
      try {
        this.vimCommunication.listenToEvent("SubAppIsReady" /* SubAppIsReady */, (message) => {
          if (message.senderId === this.widgetConfig.id)
            resolve();
        });
        await CommonConnector.injectWidget({ widget: this.widgetConfig });
      } catch (error) {
        reject(error);
      }
    });
    this.readyPromise = promise;
    return await promise;
  }
  async modifyWidget(modifyWidgetParams) {
    const input = { widget: __spreadProps(__spreadValues({}, modifyWidgetParams), { id: this.widgetConfig.id }) };
    return await CommonConnector.modifyWidget(input);
  }
  async sendData(data) {
    if (!this.readyPromise) {
      throw new Error("You must call inject widget before sending data!");
    }
    console.debug("[sendData] waiting for widget is ready...", {
      widgetConfig: this.widgetConfig,
      data
    });
    await this.readyPromise;
    console.debug("[sendData] widget is ready sending data", {
      widgetConfig: this.widgetConfig,
      data
    });
    this.vimCommunication.sendEvent(this.widgetConfig.id, "data", data);
    console.debug("[sendData] data is sent", { widgetConfig: this.widgetConfig, data });
  }
};
var SubApplicationVimCommunication = class extends VimCommunication {
  constructor(parentAppId, props) {
    super(props);
    this.parentAppId = parentAppId;
  }
  onCommunicationReady() {
    this.logger.info(`\u2705 Module is ready!`, this);
    this.sendEvent(this.parentAppId, "SubAppIsReady" /* SubAppIsReady */);
  }
};

// src/get-tab-id-from-url.ts
function getTabIdFromUrl() {
  const url = new URL(window.location.href);
  return url.searchParams.get("tabId") || "0";
}

// src/notifications/index.ts
var notifications_exports = {};
__export(notifications_exports, {
  Actions: () => notification_actions_exports,
  Types: () => types_exports
});

// src/notifications/notification-actions.ts
var notification_actions_exports = {};
__export(notification_actions_exports, {
  hideNotification: () => hideNotification,
  showNotification: () => showNotification
});
import { sendDataToVimConnectUI, EventType } from "@getvim/utils-vim-connect-communication";

// src/notifications/types.ts
var types_exports = {};
__export(types_exports, {
  NotificationEvent: () => NotificationEvent,
  NotificationToVimConnectUIEvent: () => NotificationToVimConnectUIEvent,
  VimConnectUIToNotificationEvent: () => VimConnectUIToNotificationEvent
});
var NotificationEvent = /* @__PURE__ */ ((NotificationEvent2) => {
  NotificationEvent2["Show"] = "vim-connect-ui-show-notification";
  NotificationEvent2["Hide"] = "vim-connect-ui-hide-notification";
  return NotificationEvent2;
})(NotificationEvent || {});
var NotificationToVimConnectUIEvent = /* @__PURE__ */ ((NotificationToVimConnectUIEvent2) => {
  NotificationToVimConnectUIEvent2["OnActionButtonClick"] = "notification-on-action-button-click";
  NotificationToVimConnectUIEvent2["OnOpen"] = "notification-on-open";
  NotificationToVimConnectUIEvent2["OnClose"] = "notification-on-close";
  NotificationToVimConnectUIEvent2["OnClick"] = "notification-on-click";
  NotificationToVimConnectUIEvent2["OnMouseEnter"] = "notification-on-mouse-enter";
  NotificationToVimConnectUIEvent2["OnBlocked"] = "notification-on-blocked";
  return NotificationToVimConnectUIEvent2;
})(NotificationToVimConnectUIEvent || {});
var VimConnectUIToNotificationEvent = /* @__PURE__ */ ((VimConnectUIToNotificationEvent2) => {
  VimConnectUIToNotificationEvent2["InitData"] = "init-data";
  return VimConnectUIToNotificationEvent2;
})(VimConnectUIToNotificationEvent || {});

// src/notifications/notification-actions.ts
var showNotification = (notificationShowEventPayload) => {
  const data = { event: "vim-connect-ui-show-notification" /* Show */, data: notificationShowEventPayload };
  sendDataToVimConnectUI({ event: EventType.VCHubSendToNotifications, data });
};
var hideNotification = (notificationHideEventPayload) => {
  const data = { event: "vim-connect-ui-hide-notification" /* Hide */, data: notificationHideEventPayload };
  sendDataToVimConnectUI({ event: EventType.VCHubSendToNotifications, data });
};

// src/vim-hub/index.ts
var vim_hub_exports = {};
__export(vim_hub_exports, {
  Actions: () => open_app_action_exports
});

// src/vim-hub/open-app-action.ts
var open_app_action_exports = {};
__export(open_app_action_exports, {
  openApp: () => openApp
});
import { sendDataToVimConnectUI as sendDataToVimConnectUI2, EventType as EventType2 } from "@getvim/utils-vim-connect-communication";
var openApp = (openAppPayload) => {
  const data = { event: "open-hub" /* OpenApp */, data: openAppPayload };
  sendDataToVimConnectUI2({ event: EventType2.OpenApp, data });
};

// src/modify-application/index.ts
var modify_application_exports = {};
__export(modify_application_exports, {
  modify: () => modify
});

// src/modify-application/modify-application-actions.ts
import { sendDataToVimConnectUI as sendDataToVimConnectUI3, EventType as EventType3 } from "@getvim/utils-vim-connect-communication";
var modify = (modifications) => {
  sendDataToVimConnectUI3({
    event: EventType3.VCNewModifyApplication,
    data: {
      data: modifications
    }
  });
};
export {
  modify_application_exports as ModifyApplication,
  notifications_exports as Notifications,
  RuntimeVimCommunication,
  SubApplicationVimCommunication,
  VimCommunication,
  VimCommunicationEvents,
  VimConnectSubApp,
  vim_hub_exports as VimHubActions,
  WidgetVimCommunication,
  getTabIdFromUrl,
  overrideEnvConfigQueryParamName2 as overrideEnvConfigQueryParamName
};
//# sourceMappingURL=index.js.map
